import { useTranslation } from 'react-i18next'
import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { showToast } from 'common/utils'
import { useDispatch, useSelector } from 'react-redux'
import { HomeDto, RotaSettingsUpdateBody } from '@lmc/ts-common'
import * as GlobalActions from 'actions/Global'

const useUpdateWarningsSettings = () => {
  const { t } = useTranslation()

  const home = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  )

  const dispatch = useDispatch()

  const mutationFunction = (json: RotaSettingsUpdateBody) =>
    postJSON({
      method: 'PUT',
      url: `/list/homes/${home.id}/rota`,
      json
    })

  const { mutateAsync: updateWarningsSettings } = useMutation<
    { data: HomeDto },
    unknown,
    RotaSettingsUpdateBody,
    void
  >(
    ['rota-settings', home.id],
    (values: RotaSettingsUpdateBody) => mutationFunction(values),
    {
      onSuccess: (res) => {
        dispatch(GlobalActions.setHomeDetails(res.data))
        showToast({
          title: t('SETTINGS_UPDATED')
        })
      }
    }
  )

  return updateWarningsSettings
}

export default useUpdateWarningsSettings
